module.exports = __webpack_public_path__ + "img/2.db1ee63b.png";